module.exports = __webpack_public_path__ + "static/PaulHighfield_Headshot-65de6d23278d77c37b35d0ca5bdee28d.png";